export default "__VITE_ASSET__B7NsGYz7__"